'use strict';

var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');


/**
 * 平板
 */
var TabletPC = React.createClass({

  render: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var move;
    var isVerticalScreen = this.props.direction === appTypes.Direction.VERTICAL;

    var size = styleHelper.getSize(this.props);
    var r = util.Rect.create(33,35,472,602);
    var ms = util.Size.create(537,702);
    if(!isVerticalScreen){
      util.Rect.overturn(r);
      util.Size.overturn(ms);
    }
    var sw = size.width/ms.width;
    var sh = size.height/ms.height;
    util.Rect.scale(r,sw,sh);
    util.Rect.inflate(r,5,5);

    var imgStyle = {
      width: isVerticalScreen ? w : h,
      height: isVerticalScreen ? h : w,
      position:'absolute',
      pointerEvents:'none',
      zIndex:1
    };

    var bgStyle={
      width: r.width,
      height: r.height,
      top: r.top,
      left: r.left,
      position:'absolute',
      zIndex:0,
      backgroundColor:styleHelper.getBackgroundColor(this.props)
    };

    if (!isVerticalScreen) {
      move = (w - h) / 2;
      imgStyle.transform = 'rotate(270deg) translate(' + move + 'px,' + move + 'px)'
    }

    return (<div className="component">
      <div style={bgStyle}></div>
      <img src={assetsHelper.getComponentAsset('TabletPC')}
           style={imgStyle}
      />
    </div>);
  }

});

module.exports = TabletPC;



// WEBPACK FOOTER //
// ./src/views/Components/TabletPC.jsx